// src/components/LangToggle.js
import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function LangToggle({ style = {} }) {
  const { lang, toggleLang, isAr } = useLanguage();

  return (
    <button
      onClick={toggleLang}
      title={isAr ? 'Switch to English' : 'التبديل إلى العربية'}
      style={{
        display:        'flex',
        alignItems:     'center',
        gap:            6,
        padding:        '5px 12px',
        borderRadius:   8,
        background:     'var(--bg3)',
        border:         '1px solid var(--border)',
        color:          'var(--text)',
        fontSize:       13,
        fontWeight:     600,
        cursor:         'pointer',
        transition:     'all .15s',
        ...style,
      }}
      onMouseEnter={e => e.currentTarget.style.background = 'var(--bg4)'}
      onMouseLeave={e => e.currentTarget.style.background = 'var(--bg3)'}
    >
      {isAr ? (
        <><span style={{ fontSize:15 }}>🇬🇧</span> EN</>
      ) : (
        <><span style={{ fontSize:15 }}>🇦🇪</span> عر</>
      )}
    </button>
  );
}
